export default __webpack_public_path__ + "static/media/customer2.975973f8.png";